/**
 * Navbar exclusiva para Administradores
 * Topbar limpa com info da página atual e badge admin
 */

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, IconButton,
  Box, Avatar, Menu, MenuItem, Divider, Chip
} from '@mui/material';
import MenuIcon      from '@mui/icons-material/Menu';
import LogoutIcon    from '@mui/icons-material/Logout';
import PersonIcon    from '@mui/icons-material/Person';
import { useAuth }   from '../context/AuthContext';
import { drawerWidth } from './SidebarAdmin';

const pageTitles = {
  '/admin':            'Dashboard',
  '/admin/operacional':'Operacional',
  '/admin/usuarios':   'Usuários',
  '/admin/relatorios': 'Relatórios',
  '/admin/automacao':  'Automação',
};

const NavbarAdmin = ({ handleDrawerToggle }) => {
  const { user, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const [anchor, setAnchor] = useState(null);

  const currentTitle = pageTitles[location.pathname] || 'Admin';
  const today = new Date().toLocaleDateString('pt-BR', {
    weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'
  });

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        bgcolor: '#fff',
        borderBottom: '1px solid #E2E8F0',
        color: '#0F172A',
      }}
    >
      <Toolbar sx={{ px: { xs: 2, sm: 3 }, minHeight: '60px !important' }}>
        {/* Mobile menu toggle */}
        <IconButton
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' }, color: '#64748B' }}
        >
          <MenuIcon />
        </IconButton>

        {/* Page title + date */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 18, color: '#0F172A', lineHeight: 1.2 }}>
            {currentTitle}
          </Typography>
          <Typography sx={{ fontSize: 11, color: '#94A3B8', textTransform: 'capitalize' }}>
            {today}
          </Typography>
        </Box>

        {/* Admin badge */}
        <Chip
          label="ADMIN"
          size="small"
          sx={{
            bgcolor: 'rgba(249,115,22,0.1)',
            color: '#F97316',
            fontWeight: 700,
            fontSize: 10,
            letterSpacing: '0.08em',
            border: '1px solid rgba(249,115,22,0.25)',
            height: 22,
            mr: 2,
            display: { xs: 'none', md: 'flex' },
          }}
        />

        {/* User menu */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ textAlign: 'right', display: { xs: 'none', md: 'block' }, mr: 0.5 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1E293B', lineHeight: 1.2 }}>
              {user?.nome || 'Administrador'}
            </Typography>
            <Typography sx={{ fontSize: 11, color: '#94A3B8' }}>
              {user?.email}
            </Typography>
          </Box>
          <IconButton onClick={(e) => setAnchor(e.currentTarget)} size="small">
            <Avatar
              sx={{
                width: 34, height: 34,
                background: 'linear-gradient(135deg, #F97316, #EA580C)',
                fontSize: 14, fontWeight: 700,
                boxShadow: '0 2px 8px rgba(249,115,22,0.35)',
              }}
            >
              {user?.nome?.charAt(0)?.toUpperCase() || 'A'}
            </Avatar>
          </IconButton>
        </Box>

        <Menu
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={() => setAnchor(null)}
          PaperProps={{
            elevation: 4,
            sx: {
              mt: 1, minWidth: 200,
              borderRadius: 2,
              border: '1px solid #E2E8F0',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            }
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: '#1E293B' }}>
              {user?.nome}
            </Typography>
            <Typography sx={{ fontSize: 11, color: '#94A3B8' }}>
              Administrador
            </Typography>
          </Box>
          <Divider />
          <MenuItem
            onClick={() => { setAnchor(null); navigate('/perfil'); }}
            sx={{ fontSize: 13, gap: 1.5, py: 1.2 }}
          >
            <PersonIcon sx={{ fontSize: 18, color: '#64748B' }} />
            Meu Perfil
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => { setAnchor(null); logout(); navigate('/login'); }}
            sx={{ fontSize: 13, gap: 1.5, py: 1.2, color: '#EF4444' }}
          >
            <LogoutIcon sx={{ fontSize: 18, color: '#EF4444' }} />
            Sair do sistema
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default NavbarAdmin;
